// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Payer } from "./Payer.ts";

export const lapseEntryPointTypeEnum = {
  LAPSE: "LAPSE",
} as const;

export type LapseEntryPointTypeEnumKey =
  (typeof lapseEntryPointTypeEnum)[keyof typeof lapseEntryPointTypeEnum];

export const lapseTypeEnum = {
  VANCE_LAPSE: "VANCE_LAPSE",
} as const;

export type LapseTypeEnumKey =
  (typeof lapseTypeEnum)[keyof typeof lapseTypeEnum];

export type Lapse = {
  /**
   * @type string
   */
  entryPointType: LapseEntryPointTypeEnumKey;
  /**
   * @type string, date
   */
  lapseDate: string;
  /**
   * @type string
   */
  memberId: string;
  payer: Payer;
  /**
   * @description Payer id
   * @type string
   */
  payerId: string;
  /**
   * @type string
   */
  state: string;
  /**
   * @type string
   */
  type: LapseTypeEnumKey;
  /**
   * @type string
   */
  workspaceId: string;
};
